import { render, staticRenderFns } from "./PorTipoAtoAdministrativo.vue?vue&type=template&id=7262b160&scoped=true"
import script from "./PorTipoAtoAdministrativo.vue?vue&type=script&lang=js"
export * from "./PorTipoAtoAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./PorTipoAtoAdministrativo.vue?vue&type=style&index=0&id=7262b160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7262b160",
  null
  
)

export default component.exports